import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default history;

export const historyWithForceRefresh = createBrowserHistory({ forceRefresh: true });
